import actionCreatorFactory from "typescript-fsa";


const actionCreator = actionCreatorFactory('components/ConnectionBar');

export const retryConnectionClicked =
  actionCreator('RETRY_CONNECTION_CLICKED');



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/ConnectionBar.actions.ts